const BACKEND_URL = window.location.hostname === 'localhost' 
  ? process.env.REACT_APP_BACKEND_URL 
  : window.location.origin;

export const HeroSection = ({ scrollToSection }) => {
  const handleSignup = () => {
    window.location.href = `${BACKEND_URL}/api/signup/`;
  };

  return (
    <section className="hero" data-testid="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <i className="fa-solid fa-graduation-cap"></i>
            Trusted by 500+ Educators
          </div>
          <h1 className="hero-title">
            The All-in-One Platform for <span className="highlight">Modern Tutors</span>
          </h1>
          <p className="hero-subtitle">
            Manage students, schedule classes, track attendance, process payments, 
            and communicate with parents — everything you need to grow your tutoring business.
          </p>
          
          <div className="hero-cta">
            <button className="btn btn-primary btn-lg" onClick={handleSignup} data-testid="hero-cta-btn">
              <i className="fa-solid fa-rocket"></i>
              Start Free Trial
            </button>
            <button className="btn btn-outline btn-lg" onClick={() => scrollToSection('how-it-works')}>
              <i className="fa-solid fa-play-circle"></i>
              See How It Works
            </button>
          </div>

          <div className="hero-social-proof">
            <div className="avatars">
              <div className="avatar">JD</div>
              <div className="avatar">MK</div>
              <div className="avatar">AS</div>
              <div className="avatar">+</div>
            </div>
            <span>Join 500+ tutors already using Tutrlink</span>
          </div>
        </div>

        <div className="hero-visual">
          <DashboardMockup />
        </div>
      </div>
    </section>
  );
};

const DashboardMockup = () => (
  <div className="dashboard-mockup">
    <div className="mockup-header">
      <div className="mockup-dots">
        <span className="dot red"></span>
        <span className="dot yellow"></span>
        <span className="dot green"></span>
      </div>
      <span className="mockup-title">Tutrlink Dashboard</span>
    </div>
    <div className="mockup-body">
      <div className="mockup-sidebar">
        <div className="sidebar-item active"><i className="fa-solid fa-gauge"></i></div>
        <div className="sidebar-item"><i className="fa-solid fa-users"></i></div>
        <div className="sidebar-item"><i className="fa-solid fa-calendar"></i></div>
        <div className="sidebar-item"><i className="fa-solid fa-credit-card"></i></div>
      </div>
      <div className="mockup-content">
        <div className="stat-row">
          <div className="mini-stat">
            <i className="fa-solid fa-users"></i>
            <div>
              <strong>24</strong>
              <span>Students</span>
            </div>
          </div>
          <div className="mini-stat">
            <i className="fa-solid fa-calendar-check"></i>
            <div>
              <strong>12</strong>
              <span>Sessions</span>
            </div>
          </div>
        </div>
        <div className="mini-stat highlight">
          <i className="fa-solid fa-dollar-sign"></i>
          <div>
            <strong>$2,400</strong>
            <span>This Month</span>
          </div>
        </div>
        <div className="mini-chart">
          <div className="bar" style={{height: '40%'}}></div>
          <div className="bar" style={{height: '65%'}}></div>
          <div className="bar" style={{height: '45%'}}></div>
          <div className="bar" style={{height: '80%'}}></div>
          <div className="bar" style={{height: '55%'}}></div>
          <div className="bar active" style={{height: '90%'}}></div>
        </div>
      </div>
    </div>
  </div>
);

export default HeroSection;
